<template>
  <div>
    <DSelect :items="usersAndTags"
             :isLoading="isLoading"
             :itemsSelected="selectedUsers"
             :show="showDropDown"
             :allDataLoaded="allDataLoaded"
             :multiple="multiple"
             @add="addUser"
             @remove="removeUser"
             @show="setShow"
             @update="setSelectedUsers"
             @searchText="setCreateUserText">
      <template slot="item_identifier" scope="props">
        <slot slot="item_identifier" :userId="props.userId"></slot>
      </template>
      <template slot="noMatch" v-if="showCreateButton">
        <h4>
          <span class="marg-10-right pad-10">{{ $t('vue2.dselect.no_matching_results') }} </span>
          <button class="bttn bttn-blue bttn-inline" @click.prevent="createCalendarOnDSelect">
            {{$t('vue2.dselect.create_user')}}
          </button>
        </h4>
      </template>
    </DSelect>
  </div>
</template>

<script>
  import DSelect from './DSelectCals'
  import eventbus from '../../eventbus'
  import {mapGetters} from 'vuex'
  import docendo from '../../docendo'

  export default {
    components: {DSelect},
    props: {
      showTags: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: true
      },
      showCreateButton: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      ...mapGetters([
        'usersSortedOnName'
      ]),
      isLoading () {
        return this.$store.state.isLoadingAllUsers
      },
      schoolId () {
        return window.SCHOOL.id
      },
      getSelectedUsersIds () {
        return this.selectedUsers.map(user => {
          return user.id
        })
      },
      tagsForSelect () {
        // tag_id is a ugly hardcoded value greater than largest userid
        let tags = []
        let i = 0
        this.tags.forEach(tag => {
          i++
          let oneTag = {
            tag: true,
            id: 999999999999 + i,
            name: tag,
            icon: 'icon-price-tag2'
          }
          tags.push(oneTag)
        })
        return tags
      },
      usersAndTags () {
        let items = [...this.usersSortedOnName]
        if (this.showTags) {
          this.tagsForSelect.forEach(obj => {
            items.push(obj)
          })
        }
        return items
      }
    },
    data () {
      return {
        selectedUsers: [],
        searchText: '',
        tags: [],
        showDropDown: false,
        allDataLoaded: false,
        getOnce: true
      }
    },
    watch: {
      schoolId () {
        this.$store.dispatch('getUsers', this.schoolId)
        this.getTags()
      },
      isLoading () {
        if (this.usersSortedOnName.length > 0 && this.getOnce) {
          this.getUsersFromRORInput()
        } else {
          this.setNewlyCreatedUser()
        }
      },
      selectedUsers () {
        this.setUsersOnRORInput()
        this.$emit('usersUpdated', this.selectedUsers)
      }
    },
    methods: {
      addUser (user) {
        this.$emit('add', user)
      },
      removeUser (user) {
        this.$emit('remove', user)
      },
      setShow (val) {
        this.showDropDown = val
      },
      setSelectedUsers (val) {
        this.selectedUsers = val
        this.$emit('update', this.selectedUsers)
      },
      // Name for new user
      setCreateUserText (val) {
        this.searchText = val
      },
      // Create user
      createCalendarOnDSelect () {
        this.showDropDown = false
        // Native window event - maybe use eventbus in future
        window.dispatchEvent(new window.CustomEvent('vueCreateUser', {detail: this.searchText}))
      },
      setNewlyCreatedUser () {
        for (let j = 0; j < this.usersSortedOnName.length; j++) {
          if (this.usersSortedOnName[j].id === Number(eventbus.createdId)) {
            this.selectedUsers.push(this.usersSortedOnName[j])
          }
        }
      },
      // Hack for ROR
      getUsersFromRORInput () {
        if (document.getElementById('subject_stringy_user_ids') === null || document.getElementById('subject_stringy_user_ids').value.length < 1) {
          return
        }
        let ids = document.getElementById('subject_stringy_user_ids').value
        let idsArr = ids.split(',')
        for (let i = 0; i < idsArr.length; i++) {
          for (let j = 0; j < this.usersSortedOnName.length; j++) {
            if (this.usersSortedOnName[j].id === Number(idsArr[i])) {
              this.selectedUsers.push(this.usersSortedOnName[j])
            }
          }
        }
        this.getOnce = false
      },
      // Hack for ROR
      setUsersOnRORInput () {
        if (document.getElementById('subject_stringy_user_ids') === null) {
          return
        }
        document.getElementById('subject_stringy_user_ids').value = this.getSelectedUsersIds
      },
      getTags () {
        docendo.schoolTags(this.schoolId, data => {
          this.tags = data
          this.allDataLoaded = true
        })
      }
    },
    beforeMount () {
      this.$store.dispatch('getUsers', this.schoolId)
      if (this.showTags) {
        this.getTags()
      }
    }
  }
</script>

<style scoped>
  .bttn.bttn-inline {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// DSelectUsers.vue?e6b9a514